// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SettingHorizontalSvg from '@rsuite/icon-font/lib/action/SettingHorizontal';
var SettingHorizontal = createSvgIcon({
  as: SettingHorizontalSvg,
  ariaLabel: 'setting horizontal',
  category: 'action',
  displayName: 'SettingHorizontal'
});
export default SettingHorizontal;